import { tr } from 'i18n';
import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import { X, Plus } from 'lucide-react';
import React from 'react'
import styles from '../AdminPanelPage.module.scss'

const CreateGuardForm = ({ employees = [], employeeSearch = '', setEmployeeSearch = () => {}, modalPayload = {}, setModalPayload = () => {}, closeModal = () => {}, createGuard, loadGuards = async () => {}, notifySuccess = () => {}, notifyError = () => {} }) => {
  useInterfaceLanguage();
  return (
    <>
      <label>{tr("Сотрудник")}</label>
      <input
        placeholder={tr("Поиск сотрудника...")}
        value={employeeSearch}
        onChange={(e) => setEmployeeSearch(e.target.value)}
      />
      <select value={modalPayload.employee || ''} onChange={(e) => setModalPayload(p => ({ ...p, employee: Number(e.target.value) }))}>
        <option value="">{tr("— Выберите сотрудника —")}</option>
        {employees.filter(emp => (emp.label || '').toLowerCase().includes(employeeSearch.toLowerCase())).map(emp => (
          <option key={emp.id} value={emp.id}>{tr(emp.label)}</option>
        ))}
      </select>

      <label>{tr("Телефон")}</label>
      <input placeholder={tr("Телефон")} value={modalPayload.phone || ''} onChange={(e) => setModalPayload(p => ({ ...p, phone: e.target.value }))} />
      <div style={{ display: 'flex', gap: 8 }}>
        <button onClick={() => { closeModal() }} className={styles.btn_pin_close}><X size={14} aria-hidden="true"/>{tr(" Отмена")}</button>
        <button onClick={async () => {
          try {
            await createGuard(modalPayload)
            await loadGuards()
            closeModal()
            notifySuccess(tr("Охранник создан"))
          } catch (err) { console.error(err); notifyError(err, tr("Не удалось создать охранника")) }
        }} className={styles.btn_pin}><Plus size={14} aria-hidden="true"/>{tr(" Создать")}</button>
      </div>
    </>
  )
}

export default CreateGuardForm
